<template>
  <div
    v-if="!loading"
    id="order-print"
    class="pb-1"
  >

    <order-print-page1
      :order="order"
      :patient-override="showAllPatients ? null : activePatient"
      :page-number="1"
      :page-total="pageTotal"
      :show-patient-section="!showAllPatients"
    />

    <template v-if="showAllPatients">
      <order-print-page2
        v-for="(patient, index) in patients"
        :key="patient && patient.id ? patient.id : `patient-${index}`"
        :order="order"
        :patient-override="patient"
        :page-number="index + 2"
        :page-total="pageTotal"
      />
    </template>
    <template v-else>
      <order-print-page2
        v-if="activePatient"
        :order="order"
        :patient-override="activePatient"
        :page-number="2"
        :page-total="pageTotal"
      />
    </template>

  </div>
</template>

<script>
import { cloneNested, parseRequestError, transformDatetimeToHumanReadablePretty } from '@/helpers/helpers'
import OrderPrintPage1 from '@/views/orders/OrderPrint/OrderPrintPage1.vue'
import OrderPrintPage2 from '@/views/orders/OrderPrint/OrderPrintPage2.vue'
import { isPatientVisibleInView } from '@/helpers/patient'

export default {
  components: {
    OrderPrintPage1,
    OrderPrintPage2,
  },
  inject: {
    printSettings: {
      default: null,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    order() {
      return this.$store.getters['order/getOrderData']
    },
    patients() {
      const patients = Array.isArray(this.order.patientInfo) ? this.order.patientInfo : []
      return patients.filter(patient => isPatientVisibleInView(patient))
    },
    currentPrintMode() {
      if (this.printSettings && this.printSettings.mode) {
        return this.printSettings.mode
      }
      return 'single'
    },
    currentSelectedPatientIndex() {
      if (this.printSettings) {
        return this.printSettings.selectedPatientIndex || 0
      }
      return 0
    },
    activePatient() {
      if (!this.patients.length) {
        return null
      }
      const index = Math.min(Math.max(this.currentSelectedPatientIndex, 0), this.patients.length - 1)
      return this.patients[index]
    },
    showAllPatients() {
      return this.currentPrintMode === 'all' && this.patients.length > 1
    },
    pageTotal() {
      if (this.showAllPatients) {
        return 1 + this.patients.length
      }
      return this.activePatient ? 2 : 1
    },
    me() {
      return cloneNested(this.$store.getters['auth/getUser'])
    },
  },
  created() {
    this.initOrderData(this.$route.params.id)
  },
  methods: {
    transformDatetimeToHumanReadablePretty,
    initOrderData(orderId) {
      return this.$store.dispatch('order/fetchOrderById', orderId)
        .then(() => {
          this.loading = false
          this.$nextTick(() => this.$emit('print-ready'))
        })
        .catch(err => parseRequestError(err))
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
